import { render, staticRenderFns } from "./ItemDL.vue?vue&type=template&id=2ffbee0d"
import script from "./ItemDL.vue?vue&type=script&lang=js"
export * from "./ItemDL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports